import { Component, OnInit } from '@angular/core';
import { CtaService } from "../../_services/cta.service";

@Component({
  selector: 'bxl-planning-services',
  templateUrl: 'planning-services.component.html',
})
export class PlanningServicesComponent implements OnInit {
  initialized = false;
  constructor(public ctaService:CtaService) { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
